import { axios } from './config';

export const getSplitDocForSite = (siteId) => {
	return axios.get(`/cb/splitDoc/${siteId}`);
};

export const createSplitDocForSite = (payload) => {
	return axios.post('/cb/splitDoc/', payload);
};

export const updateSplitDocForSite = (payload) => {
	return axios.put(`/cb/splitDoc/`, payload);
};

export const syncSplitDocForSite = (payload) => {
	return axios.post('/cb/splitDoc/sync', payload);
};
